import React from 'react';

import { BorderColor as BorderColorIcon } from '@mui/icons-material';
import { useNavigate } from 'react-router';

import { appRoutes, RouterEntitiesId } from '@clearverify/constants';

import { DataDisputeReportInfoFragment } from 'src/api';
import { TableRowAction } from 'src/components/table';
import { buildUrl } from 'src/utils/router';

export function useDataDisputeReportTableRowActions() {
  const navigate = useNavigate();

  const viewDetails: TableRowAction<DataDisputeReportInfoFragment> = React.useMemo(
    () => ({
      startIcon: React.createElement(BorderColorIcon),
      actionName: 'View Details',
      onAction: dataDisputeReport => {
        navigate(
          buildUrl(appRoutes.inbox.inboxItem, {
            [RouterEntitiesId.inboxItem]: dataDisputeReport.inboxItemId,
          }),
        );
      },
    }),
    [navigate],
  );

  return [viewDetails];
}
